export const SALES_EMPTY_BRANCH = {
  authorizationIds: [] as string[],
  branchId: undefined,
  professionId: undefined,
};
